import React from 'react';

interface PageContextInterface {
  name: string;
  category?: string;
}

const PageContext = React.createContext<PageContextInterface>({
  name: '',
  category: '',
});

interface ProviderProps {
  name: string;
  category?: string;
}

const PageProvider: React.FC<ProviderProps> = ({
  name,
  category,
  children,
}) => (
  <PageContext.Provider value={{ name, category }}>
    {children}
  </PageContext.Provider>
);

const usePageContext = () => React.useContext(PageContext);

export const usePage = usePageContext;

const PageConsumer = PageContext.Consumer;

export { PageProvider };
export { PageConsumer };
export default PageContext;
